var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticClass: "c-background",
          staticStyle: { "background-color": "rgb(0, 140, 0)" },
          attrs: { disabled: _vm.$store.getters.tallyLock },
          on: { click: _vm.deskClick }
        },
        [_c("span", { staticStyle: { color: "#fff" } }, [_vm._v(" 工作台")])]
      ),
      _vm._v(" "),
      _vm.deskNo
        ? _c("el-button", { attrs: { type: "info", disabled: "" } }, [
            _vm._v(_vm._s(_vm.deskNo))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-122ca0c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122ca0c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YsComponents/YsWorkDesk.vue
// module id = null
// module chunks = 